var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69922 1.0498H9.29922C9.84922 1.0498 10.2992 1.4998 10.2992 2.0498V3.1498C10.2992 3.5498 10.0492 4.0498 9.79922 4.2998L7.64922 6.1998C7.34922 6.4498 7.14922 6.9498 7.14922 7.3498V9.4998C7.14922 9.7998 6.94922 10.1998 6.69922 10.3498L5.99922 10.7998C5.34922 11.1998 4.44922 10.7498 4.44922 9.9498V7.2998C4.44922 6.9498 4.24922 6.4998 4.04922 6.2498L2.14922 4.2498C1.89922 3.9998 1.69922 3.5498 1.69922 3.2498V2.0998C1.69922 1.4998 2.14922 1.0498 2.69922 1.0498Z",
    stroke: "#808FD4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.f1af5417dc2b3cb101735ddb8c5e5d8f.svg";
export { ForwardRef as ReactComponent };